// extracted by mini-css-extract-plugin
export default {"title":"style_title__VKPjS","prodoctsList":"style_prodoctsList__I64ka"};